<template>
  <div v-if="type === 'outline' || type === 'fill' || type === 'blank'" :style="{
    borderRadius: radius + 'px',
    minHeight: tagSize + 'px',
    fontSize: tagSize === 'small' ? '12px' : '',
    border: type === 'fill' ? 'none' : '',
    backgroundColor: type === 'blank' ? SCSS_VARIABLES.COLOR_TEXT_WHITE : ''
  }" :class="{
  'rt-tag-outline': true,
  'is-disabled': disabled
}">
    <span :style="{ WebkitLineClamp: line, maxWidth: maxWidth + 'px' }" :class="[textType ? 'is-primary' : '']"
      class="tag-text" @click="onClick">
      <slot />
    </span>
    <rt-icon v-if="closable && !disabled" :color="SCSS_VARIABLES.COLOR_INFO"
      :name="closeChange ? 'rt-base-close_fill' : 'rt-base-close-x'" class="tag-close" :size="closeIconSize"
      @mouseover.native="closeChange = true" @mouseleave.native="closeChange = false" @click.stop="close" />
  </div>
  <div v-else :class="classes" :style="{
    '--opacitie': borderOpacity,
    borderRadius: radius + 'px',
    minHeight: tagSize + 'px',
    paddingLeft: tagPadding + 'px',
    paddingRight: tagPadding + 'px',
    maxWidth: maxWidth + 'px'
  }">
    <div v-if="isDot" class="is-dot"></div>
    <slot name="icon-left">
      <div v-if="icon && iconDirection === 'left'" class="__icon-left">
        <rt-icon :name="icon" :img-src="iconSrc" :color="iconColor" @click.stop="close"></rt-icon>
      </div>
    </slot>
    <span :class="{ 'dot-text': isDot }" :style="{ WebkitLineClamp: line }" class="rt-tag-text">
      <slot />
    </span>
    <slot name="icon-right">
      <div v-if="icon && iconDirection === 'right'" class="__icon-right">
        <rt-icon :name="icon" :img-src="iconSrc" :color="iconColor" @click.stop="close"></rt-icon>
      </div>
    </slot>
    <rt-icon v-if="closable && !disabled" :color="closableIconColor"
      :name="closeChange ? 'rt-base-close_fill' : 'rt-base-close-x'" class="tag-close" :size="closeIconSize"
      @mouseover.native="closeChange = true" @mouseleave.native="closeChange = false" @click.stop="close" />
  </div>
</template>

<script>
import RtIcon from '../icon/rtIcon';
export default {
  name: 'RtTag',
  components: {
    RtIcon
  },
  props: {
    icon: {
      type: String,
      default: ''
    },
    border: {
      type: Boolean,
      default: false
    },
    borderOpacity: {
      type: Number,
      default: 0.5
    },
    textType: {
      type: String
    },
    light: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    iconDirection: {
      type: String,
      default: 'left'
    },
    iconColor: String,
    // 关闭图标的颜色
    closableIconColor: {
      type: String,
      default: function () {
        return this.SCSS_VARIABLES.COLOR_INFO;
      }
    },
    colorType: {
      type: String,
      default: 'info'
    },
    iconSrc: {
      type: String,
      default: ''
    },
    isDot: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean
    },
    type: {
      type: String,
      default: 'plain'
    },
    line: {
      type: Number,
      default: 1
    },
    radius: {
      type: String,
      default: '4'
    },
    size: {
      type: String,
      default: 'large'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: Number,
      default: 200
    }
  },
  data() {
    return {
      closeChange: false
    };
  },
  computed: {
    // 控制关闭图标的大小
    closeIconSize() {
      switch (this.size) {
        case 'small':
          return '12';
        case 'medium':
          return '14';
        case 'large':
          return '16';
        default:
          return this.size;
      }
    },
    tagSize() {
      switch (this.size) {
        case 'small':
          return '18';
        case 'medium':
          return '20';
        case 'large':
          return '24';
        default:
          return this.size;
      }
    },
    tagPadding() {
      switch (this.size) {
        case 'small':
          return '4';
        case 'medium':
          return '6';
        case 'large':
          return '8';
        default:
          return '8';
      }
    },
    classes() {
      let classes = [
        'rt-tag',
        `rt-tag-${this.colorType}`,
        this.light ? ['is-light', 'rt-tag-border'] : '',
        this.dark ? 'is-dark' : '',
        this.border ? 'rt-tag-border' : ''
      ];
      if (this.isDot) {
        classes.push('rt-tag-is-dot');
      }
      return classes;
    }
  },
  methods: {
    close(event) {
      !this.disabled && this.$emit('close', event);
    },
    onClick() {
      !this.disabled && this.$emit('click');
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtTag.vue?51b2cb4a